import { Button, Text } from '@eqi-investimentos/react';
import { Icon } from '@/components/elements/Icon';
import { EDIT_PROFILE_INFO_DRAWER_IDS } from '../utils';

export const EditPasswordButton = () => (
  <Button
    variant="naked"
    onClick={() =>
      window.dispatchEvent(
        new CustomEvent(
          `open-chakra-modal-${EDIT_PROFILE_INFO_DRAWER_IDS.password}`
        )
      )
    }
    justifyContent="space-between"
    w="full"
    color="content.primary"
  >
    <Text size="xl">Alterar senha</Text>
    <Icon iconName="ChevronRight" w="24" h="24" color="content.brand " />
  </Button>
);
